(function () {
  if (window.__storySectionModalInit) return;
  window.__storySectionModalInit = true;

  var SCOPE   = '.shopify-section';
  var MODAL   = '.pair-modal';
  var OPEN    = 'open';
  var TRIGGER = '[onclick*="openTeasModal"]';

  function lockScroll()   { document.body.style.overflow = 'hidden'; }
  function unlockScroll() { if (!document.querySelector(MODAL + '.' + OPEN)) document.body.style.overflow = ''; }

  function openModal(modal) {
    if (!modal) return;
    modal.classList.add(OPEN);
    lockScroll();
    var panel = modal.querySelector('.pair-modal-panel');
    if (panel) panel.scrollTop = 0;
    var closeBtn = modal.querySelector('.pair-modal-close');
    if (closeBtn) closeBtn.focus();
  }

  function closeModal(modal) {
    if (!modal) return;
    modal.classList.remove(OPEN);
    unlockScroll();
  }

  function modalFor(trigger) {
    if (!trigger || !trigger.closest) return null;

    var scope = trigger.closest(SCOPE);
    if (!scope) return null;

    var modals = scope.querySelectorAll(MODAL);
    if (!modals.length) return null;
    if (modals.length === 1) return modals[0];

    var triggers = scope.querySelectorAll(TRIGGER);
    var i = Array.prototype.indexOf.call(triggers, trigger);
    return modals[i] || null;
  }

  var lastTrigger = null;
  document.addEventListener('click', function (e) {
    var el = e.target;
    var trigger = (el && el.closest) ? el.closest(TRIGGER) : null;
    lastTrigger = trigger;
    if (trigger && trigger.tagName === 'A') e.preventDefault();
  }, true);

  window.openTeasModal = function (arg) {
    var el = null;
    if (arg && arg.nodeType === 1)  el = arg;
    else if (arg && arg.target)     el = arg.currentTarget || arg.target;
    else                            el = lastTrigger;

    var trigger = (el && el.closest) ? (el.closest(TRIGGER) || el) : null;
    openModal(modalFor(trigger));
  };

  document.addEventListener('click', function (e) {
    var el = e.target;
    if (!el || !el.closest) return;

    var closeBtn = el.closest('.pair-modal-close');
    if (closeBtn) { closeModal(closeBtn.closest(MODAL)); return; }

    if (el.classList.contains('pair-modal')) closeModal(el);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var opened = document.querySelectorAll(MODAL + '.' + OPEN);
    if (opened.length) closeModal(opened[opened.length - 1]);
  });
  
})();

(function () {
  document.querySelectorAll('.jarGallery').forEach(wrap => {
    const slides = wrap.querySelectorAll('.jar-slide');
    if (!slides.length) return;

    const caption = wrap.querySelector('.jarCaption');
    const prev = wrap.querySelector('.jarPrev');
    const next = wrap.querySelector('.jarNext');

    // label lấy từ data-title của ảnh (fallback: data-title của slide, rồi alt)
    const labelOf = slide => {
      const img = slide.matches('img') ? slide : slide.querySelector('img');
      return (img && (img.dataset.title || img.alt)) || slide.dataset.title || '';
    };

    let i = 0;
    const show = n => {
      i = (n + slides.length) % slides.length;
      slides.forEach((s, k) => s.classList.toggle('active', k === i));
      if (caption) caption.textContent = labelOf(slides[i]);
    };

    if (prev) prev.addEventListener('click', () => show(i - 1));
    if (next) next.addEventListener('click', () => show(i + 1));

    show(0);
  });
})();


  // OUR FLAVORS dialog — opened from the "Discover our flavors" link in the first story row.
  (function(){
    const modal = document.getElementById('flavorsModal');
    if(!modal) return;
    const close = () => { modal.classList.remove('open'); document.body.style.overflow = ''; };
    window.openFlavorsModal = function(){
      // Cloned rather than duplicated in the source: edit the section at the bottom of the
      // page and the dialog follows automatically.
      const body = document.getElementById('flavorsModalBody');
      const section = document.getElementById('flavors');
      if(body && section && !body.childElementCount) body.innerHTML = section.innerHTML;
      modal.classList.add('open');
      document.body.style.overflow = 'hidden';
      const p = modal.querySelector('.pair-modal-panel');
      if(p) p.scrollTop = 0;
    };
    const btn = document.getElementById('flavorsCloseBtn');
    if(btn) btn.addEventListener('click', close);
    modal.addEventListener('click', e => { if(e.target === modal) close(); });
    document.addEventListener('keydown', e => {
      if(e.key === 'Escape' && modal.classList.contains('open')) close();
    });
  })();